<div class="flex h-full flex-col overflow-hidden" data-cy="kala-orders">
	@if (filterPanel()) {
		<div data-cy="order-list-filter" class="flex flex-col gap-2 p-2 select-none">
			<ui-input-search
				placeholder="جستجو نماد"
				model="fill"
				size="lg"
				keyboardLanguage="persian"
				dataCy="order-filter-input"
				[clearButton]="true"
				[value]="filterObject().searchInput"
				(valueChange)="onSearchChange($event)"
				(searchCleared)="onSearchChange('')" />

			<div class="flex items-start justify-around px-2 py-1">
				<button
					type="button"
					class="flex flex-1 flex-col items-center gap-1 text-gray-700"
					data-cy="order-list-sell-filter"
					aria-label="فیلتر فروش"
					(click)="toggleColorFilter('showRed')">
					<ui-icon class="text-red-500" width="18" height="18" [iconName]="redLightIcon()" />
					<span class="text-xs">فروش</span>
				</button>

				<button
					type="button"
					class="flex flex-1 flex-col items-center gap-1 text-gray-700"
					data-cy="order-list-buy-filter"
					aria-label="فیلتر خرید"
					(click)="toggleColorFilter('showGreen')">
					<ui-icon class="text-green-500" width="18" height="18" [iconName]="greenLightIcon()" />
					<span class="text-xs">خرید</span>
				</button>

				<button
					type="button"
					class="flex flex-1 flex-col items-center gap-1 text-gray-700"
					data-cy="order-list-done-filter"
					aria-label="فیلتر انجام شده"
					(click)="toggleColorFilter('showDone')">
					<ui-icon class="text-blue-500" width="18" height="18" [iconName]="blueLightIcon()" />
					<span class="text-xs">انجام شده</span>
				</button>
			</div>
		</div>
	}

	@if (loading() && orders().length === 0) {
		<div class="flex grow items-center justify-center" data-cy="order-list-loading">
			<ui-loading message="در حال دریافت سفارش‌ها ..." />
		</div>
	} @else if (error()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="order-list-error"
			variant="error"
			description=""
			iconName="alert-box"
			primaryButtonLabel="تلاش مجدد"
			[title]="error()!"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else if (emptyStateTitle()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="order-list-empty"
			description=""
			variant="empty"
			[title]="emptyStateTitle()">
			<ui-button
				variant="mofid"
				model="outline"
				size="lg"
				data-cy="order-list-empty-history-link"
				[label]="orderHistoryLabel()"
				(clicked)="onOrderHistoryClicked()" />
		</ui-empty-state>
	} @else {
		<div
			#ordersList
			swipeRightLeft
			swipeWidth="150"
			class="min-h-0 flex-1 overflow-y-auto w-full"
			[class.pb-4]="toolbarActive()">
			@for (order of filteredOrders(); track order.orderId) {
				<app-order-card-item
					[order]="order"
					[selectionMode]="toolbarActive()"
					[isChecked]="isOrderSelected(order.orderId)"
					(detailRequested)="onOrderDetailRequested($event)"
					(deleteRequested)="onOrderDeleteRequested($event)"
					(checkboxChanged)="checkboxChanged($event)"
					(holdEvent)="onHoldEvent($event)" />
			}

			@if (filteredOrders().length > 0) {
				<div class="flex justify-center py-2">
					<ui-button
						variant="ghost"
						size="lg"
						data-cy="order-list-history-link"
						[label]="orderHistoryLabel()"
						(clicked)="onOrderHistoryClicked()">
						<ui-icon leftIcon width="20" height="20" iconName="time" />
					</ui-button>
				</div>
			}
		</div>
	}

	@if (toolbarActive()) {
		<div
			data-cy="order-list-toolbar"
			class="flex items-center z-10 fixed left-4 right-4 shadow-lg justify-between gap-1 rounded-xl bg-gray-100 py-2 px-4 bottom-24">
			<div class="flex flex-1 flex-col items-center gap-1">
				<ui-checkbox
					structure="controlOnly"
					[ariaLabel]="allOrdersSelected() ? 'لغو انتخاب' : 'انتخاب همه سفارش‌ها'"
					[checked]="allOrdersSelected()"
					(valueChange)="toggleSelectAll()" />
				<p class="font-medium text-2.75 text-gray-900">
					{{ allOrdersSelected() ? 'لغو انتخاب' : 'انتخاب همه' }}
				</p>
			</div>

			<button
				type="button"
				data-cy="order-list-toolbar-delete"
				class="flex flex-1 flex-col items-center gap-1"
				[disabled]="!deleteToolbarActive()"
				(click)="onDeleteSelectedOrdersClicked(); $event.stopPropagation()">
				<ui-icon width="22" height="22" class="text-red-500" iconName="delete" />
				<p
					class="font-medium text-2.75"
					[class.text-gray-900]="deleteToolbarActive()"
					[class.text-gray-400]="!deleteToolbarActive()">
					حذف {{ selectedOrdersCountLabel() }}
				</p>
			</button>

			<button
				type="button"
				data-cy="order-list-toolbar-close"
				class="flex flex-1 flex-col items-center gap-1 text-gray-900/50"
				(click)="closeToolbar()">
				<ui-icon width="22" height="22" iconName="close-box" />
				<p class="font-medium text-2.75 text-gray-900">بستن</p>
			</button>
		</div>
	}

	<app-order-detail-bottom-sheet
		#detailSheet
		[order]="selectedOrder()"
		[lastPrice]="selectedOrderLastPrice()"
		(cancelRequested)="onDetailCancelRequested()" />

	<app-order-cancel-bottom-sheet #cancelSheet (dismissed)="onCancelDismissed()" (cancelled)="onOrderCancelled()" />

	<app-orders-actions-bottom-sheet #actionsSheet (actionSelected)="onActionSelected($event)" />

	<app-order-settings-bottom-sheet #settingsSheet />
</div>
